<template>
  <section v-if="!isLoggedIn" :class="[$style.root, $style.red]">
    <div :class="$style.blue">
      <div :class="$style.yellow">
        <div :class="$style.darkBlue">
          <h1 :class="$style.title">{{ $t('component.winevercard.title') }}</h1>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
const { isLoggedIn } = useAuth()
</script>

<style lang="scss" module>
.root {
  margin: -1 * token('size/space/gap/050') 0 token('size/space/gap/100');

  @include media-desktop {
    margin-bottom: token('size/space/gap/200');
  }
}

.red {
  padding: token('size/space/gap/100') token('size/space/gap/200');
  border-radius: token('size/space/gap/100');
  background: token('color/red/600');

  @include media-desktop {
    margin-bottom: token('size/space/gap/200');
  }
}

.blue {
  max-width: 500px;
  margin: 0 auto;
  padding: token('size/space/gap/100') token('size/space/gap/200');
  border-radius: token('size/space/gap/050');
  background: token('color/blue/500');
}

.yellow {
  max-width: 356px;
  margin: 0 auto;
  padding: token('size/space/gap/100') token('size/space/gap/200');
  border-radius: token('size/space/gap/050');
  background: token('color/yellow/700');
}

.dark-blue {
  max-width: 276px;
  margin: 0 auto;
  padding: token('size/space/gap/050') token('size/space/gap/200');
  border-radius: token('size/space/gap/050');
  background-color: token('color/blue/950');
}

.title {
  width: 100%;
  max-width: 232px;
  height: 26px;
  margin: 0 auto;
  background: url('./assets/winever-text.svg') center no-repeat;
  background-size: contain;
  text-indent: -9999px;
}
</style>
